import { ApiEndPoint } from './apiEndPoint'

export const getSavedProducts = new ApiEndPoint('products')
export const getSavedProductById = new ApiEndPoint('products/{productId}')